import { CodatState } from "../stores/ui/ui-state";

export interface CodatURLDecorations {
    host: string;
    protocol: string;
    journeyId: string;
    taskId: string;
    step: number;
    journeyName?: string;
    taskName?: string;
    connectRoute?: string;
}

export const extractCodatResponse = (query: URLSearchParams): CodatState => {
    return {
        platformName: query.get('platformName'),
        statusCode: query.get('statusCode'),
        errorMessage: query.get('errorMessage'),
        companyId: query.get('companyId'),
        integration: query.get('integration'),
        step: parseInt(query.get('step'))
    }
};

export const decorateCodatURL = (url: string, decorations: CodatURLDecorations): string => {
    let {protocol, host, journeyId, journeyName = '', taskId, taskName = '', step, connectRoute } = decorations;
    protocol = decorations.protocol.replace(':','');
    let path = connectRoute ? connectRoute : `/journey/${journeyName || journeyId}/task/${taskName || taskId}`
    let params = encodeURIComponent(`&integration=codat&step=${step}`)

    return url + `?protocol=${protocol}&host=${host}&path=${path}&params=${params}`
}

export const isCodatConnectionSuccessful = (codatState: CodatState): boolean => {
    if (!codatState) return false;

    const stateFromFenergo = (state) => !!state.companyId && !!state.platformName
    const stateFromCodat = (state) => state.statusCode == null || !!state.statusCode?.match(/^20\d$/)
    return stateFromFenergo(codatState) && stateFromCodat(codatState)
}